import { Component } from 'react';
import PropTypes from 'prop-types';
// lodash
import get from 'lodash/get';
// redux
import { connect } from 'react-redux';
import {
  submitAndHandleAppsHandover,
  submitAndHandleHandover,
  submitAndHandlePactHandover,
} from '../../redux/actions/bff/bffActions';
import routeConstants from '../../constants/routeConstants';
import { APPS_AUTHENTICATED_HANDOVER, APPS_GUEST_HANDOVER } from '../../constants/actionConstants';
import { showDisableSiteSpinner } from '../../redux/actions/app/appActions';
import getCookieValue from '../../utils/helpers/cookie/getCookie';

export class SessionManager extends Component {

  static propTypes = {
    auth0AccessToken: PropTypes.string,
    basketId: PropTypes.string,
    biom: PropTypes.string,
    children: PropTypes.element.isRequired, // from react-router
    dynUserConfirm: PropTypes.string,
    dynUserId: PropTypes.string,
    email: PropTypes.string,
    environmentId: PropTypes.string,
    expressCheckout: PropTypes.string,
    getLoginPageComplete: PropTypes.bool,
    isAppsAuthenticatedHandover: PropTypes.bool,
    isAppsGuestHandover: PropTypes.bool,
    isPactHandover: PropTypes.bool,
    jsessionId: PropTypes.string,
    lbnscId: PropTypes.string,
    monetateId: PropTypes.string,
    pedId: PropTypes.string,
    requestAccessToken: PropTypes.func,
    sessionHandoverComplete: PropTypes.bool,
    sessionHandoverFailed: PropTypes.bool,
    showDisableSiteSpinner: PropTypes.func,
    source: PropTypes.string,
    storeId: PropTypes.string,
    submitAndHandleAppsHandover: PropTypes.func.isRequired,
    submitAndHandleHandover: PropTypes.func.isRequired,
    submitAndHandlePactHandover: PropTypes.func.isRequired,
    visitorId: PropTypes.string,
  };

  static defaultProps = {
    auth0AccessToken: undefined,
    basketId: undefined,
    biom: '',
    children: null,
    dynUserConfirm: undefined,
    dynUserId: undefined,
    email: '',
    environmentId: '',
    expressCheckout: undefined,
    getLoginPageComplete: false,
    isAppsAuthenticatedHandover: false,
    isAppsGuestHandover: false,
    isPactHandover: false,
    jsessionId: '',
    lbnscId: '',
    monetateId: undefined,
    pedId: '',
    requestAccessToken: undefined,
    sessionHandoverComplete: false,
    sessionHandoverFailed: false,
    showDisableSiteSpinner: window.defaultFunc,
    source: '',
    storeId: '',
    submitAndHandleAppsHandover: window.defaultFunc,
    submitAndHandleHandover: window.defaultFunc,
    submitAndHandlePactsHandover: window.defaultFunc,
    visitorId: '',
  };

  componentDidMount() {
    const {
      basketId,
      storeId,
      pedId,
      sessionHandoverComplete,
      sessionHandoverFailed,
      source,
      jsessionId,
      lbnscId,
      dynUserId,
      dynUserConfirm,
      isPactHandover,
      isAppsGuestHandover,
      isAppsAuthenticatedHandover,
      email,
      environmentId,
      visitorId,
      biom,
      showDisableSiteSpinner,
      monetateId,
      expressCheckout,
    } = this.props;

    if (isAppsAuthenticatedHandover) {
      showDisableSiteSpinner();
      return;
    }

    if (isAppsGuestHandover) {
      showDisableSiteSpinner();
      this.props.submitAndHandleAppsHandover({
        actionType: APPS_GUEST_HANDOVER,
        jsessionId,
        lbnscId,
        dynUserId,
        dynUserConfirm,
        email,
        environmentId,
        visitorId,
        biom,
        basketId,
        monetateId,
      });
      return;
    }

    if (isPactHandover) {
      showDisableSiteSpinner();

      this.props.submitAndHandlePactHandover({
        environmentId,
        visitorId,
        storeId,
        pedId,
        source,
        basketId,
      });
      return;
    }

    if (!sessionHandoverComplete && !sessionHandoverFailed) {
      this.props.submitAndHandleHandover({
        express: expressCheckout === 'true',
        basketId,
      });
    }
  }

  isAccessTokenProvided(prevProps) {
    return this.props.isAppsAuthenticatedHandover && !prevProps.auth0AccessToken && this.props.auth0AccessToken;
  }

  componentDidUpdate(prevProps) {
    const {
      jsessionId,
      lbnscId,
      dynUserId,
      dynUserConfirm,
      isAppsAuthenticatedHandover,
      environmentId,
      visitorId,
      biom,
      auth0AccessToken,
      requestAccessToken,
      basketId,
      monetateId,
    } = this.props;

    if (isAppsAuthenticatedHandover
      && !prevProps.requestAccessToken
      && requestAccessToken) {
      requestAccessToken();
      return;
    }

    if (this.isAccessTokenProvided(prevProps)) {
      this.props.submitAndHandleAppsHandover({
        actionType: APPS_AUTHENTICATED_HANDOVER,
        jsessionId,
        lbnscId,
        dynUserId,
        dynUserConfirm,
        environmentId,
        visitorId,
        biom,
        basketId,
        accessToken: auth0AccessToken,
        monetateId,
      });
    }
  }

  render() {
    const { children, getLoginPageComplete } = this.props;

    return getLoginPageComplete ? children : null;
  }
}

export function mapStateToProps(state, ownProps) {
  const searchParams = new URLSearchParams(get(ownProps, 'location.search'));
  const query = Object.fromEntries(searchParams);
  const pathname = get(state.router, 'location.pathname');

  return {
    sessionHandoverComplete: state.bff?.sessionHandoverComplete,
    sessionHandoverFailed: state.bff?.sessionHandoverFailed,
    getLoginPageComplete: state.login?.getLoginPageComplete,
    isPactHandover: routeConstants.PACT_HANDOVER === pathname,
    isAppsGuestHandover: routeConstants.APPS_GUEST_HANDOVER === pathname,
    isAppsAuthenticatedHandover: routeConstants.APPS_AUTHENTICATED_HANDOVER === pathname,
    jsessionId: query.jsessionId,
    lbnscId: query.lbnscId,
    dynUserId: query.dynUserId,
    dynUserConfirm: query.dynUserConfirm,
    email: query.email,
    environmentId: query.envId,
    visitorId: query.vid,
    biom: query.biom,
    storeId: query.storeId,
    pedId: query.pedId,
    source: query.source,
    auth0AccessToken: get(state.mobileApps, 'auth0AccessToken'),
    requestAccessToken: get(state.mobileApps, 'requestAccessToken'),
    basketId: query.basketId || getCookieValue('basket_id'),
    monetateId: query.monetateId,
    expressCheckout: query.express,
  };
}

export function mapDispatchToProps() {
  return {
    submitAndHandleHandover,
    submitAndHandlePactHandover,
    submitAndHandleAppsHandover,
    showDisableSiteSpinner,
  };
}

export default connect((state, ownProps) => mapStateToProps(state, ownProps), mapDispatchToProps())(SessionManager);
